<template>
  <div class="main-conent main-conent-maxheight page-sample">
    <el-tabs tab-position="left" class="category-tabs">
      <el-tab-pane
        v-for="item in categories"
        :key="item.id"
        :label="item.name"
        :lazy="true"
      >
        <images :id="item.id"></images>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
const Images = () => import('./components/images')

export default {
  components: { Images },
  mounted() {}
}
</script>

<style lang="scss">
.page-sample {
  .category-tabs,
  .el-tabs__content,
  .el-tab-pane {
    height: 100%;
  }
}
</style>
